import axios from 'axios'
import qs from 'qs'

const instance = axios.create({
    withCredentials: false,
    headers: {'X-Requested-With': 'XMLHttpRequest'},
    paramsSerializer: function (params) {
        return qs.stringify(params, {arrayFormat: 'repeat'})
    }
})

export default instance
